module.exports = __webpack_public_path__ + "img/dario.f889bca2.png";